/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit ModalFullScreenNative/view.blocks to change it.
import Children from 'Simple/Children'
import React from 'react'
import styles from './view.module.css'
import useIsBefore from 'Simple/hooks/useIsBefore'
import useIsHovered from 'Simple/hooks/useIsHovered'
import viewPath from './viewPath.js'
import { DialogOverlay as ViewsModalOverlay, DialogContent as ViewsModalOverlayContent } from '@reach/dialog'



/**
 * @type {(
 *  props: {
 *    [x: string]: any,
 *    children?: React.ReactNode,
 *    viewPath: typeof viewPath
 *  }) => React.JSX.Element}
 */
export default function ModalFullScreenNative({
  children,
  viewPath = "/DesignSystem/ModalFullScreenNative",
  onClick,
  onDismiss
  
}) {
  let isBefore = useIsBefore()
let [isHovered, isSelectedHovered, isHoveredBind] = useIsHovered({})
  return (<React.Fragment
>
<ViewsModalOverlay
  data-testid="ModalFullScreenNative.Horizontal"
  data-view-path={viewPath}
 visible={true}
 transparent={true}
 {...isHoveredBind}
 onClick={onClick}
 onDismiss={onDismiss}
 style={{'--bc-1-1IdUoR': isBefore ? "rgba(230, 230, 230, 0)" : "rgba(230, 230, 230, 0.5)"}}
 className={`views-block ${styles.Horizontal}`}
>
<ViewsModalOverlayContent
  data-testid="ModalFullScreenNative.ModalContent"
  data-view-path={viewPath}
 className={`views-block ${styles.ModalContent}`}
>
<Children
  viewPath={`${viewPath}/Children`}
>
{children}
</Children>
</ViewsModalOverlayContent>
</ViewsModalOverlay>
</React.Fragment>)
}